import React, { useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@mui/material";
import { Button } from "../../../../../stories/Button/Button";
import CheckAll from "../../../../../images/MoreInfo.svg";
import Filter from "../../../../../images/Filter.svg";
import DownArrow from "../../../../../images/DownArrow.svg";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { StockEntryTable } from "../stockentry/Add/Add";
import { Label } from "../../../../../stories/Label/Label";
import {
  labelClasses,
  LabeledAutocomplete
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent
} from "../../../../../utils/UtilFunctions";
import Input from "../../../../../stories/Input/Input";
import { useNavigate } from "react-router-dom";
import {
  ViewConfigurationStyles,
  ViewModalStyles
} from "../../../../../styles/CustomModalStyles";
import LocationDetails from "./LocationDetails";
import ItemDetails from "./ItemDetails";
import ViewConfiguration from "../stockentry/ViewConfiguration";
import MainStore from "../../../../../images/MainStore.svg";
import SubStore from "../../../../../images/SubStore.svg";
import StockInHand from "../../../../../images/StockInHand.svg";
import Total from "../../../../../images/Total.svg";
import TotalLocation from "../../../../../images/TotalLocation.svg";
import Calendar from "../../../../../images/Calendar.svg";
import CalendarBlack from "../../../../../images/CalendarBlack.svg";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes, PageFor } from "../../../../../utils/Enum.types";
const options = ["IT Equipment", "Tools and Machinery", "Softwares"];
interface Props {
  pageType: PageFor;

}
export const totalData = [
  {
    title: "Main Store",
    image: `${MainStore}`,
    count: 0
  },
  {
    title: "Sub Store",
    image: `${SubStore}`,
    count: 0
  },
  {
    title: "Stock In Hand",
    image: `${StockInHand}`,
    count: 0
  },
  {
    title: "Total",
    image: `${Total}`,
    count: 0
  },
  {
    title: "Total Location",
    image: `${TotalLocation}`,
    count: 0
  }
];

const StockBalanceAdd = ({ pageType }: Props) => {
  const navigate = useNavigate();
  const { Purchase } = useAssetTableJson();
  const [filterColumns, setFilterColumns] = useState(false);
  const [viewConfig, setViewConfig] = useState(false);
  const [locationDetails, setLocationDetails] = useState(false);
  const [columns, setColumns] = useState(Purchase.StockEntry.Add.SubHeader);
  const handleColumnToggle = (field: string) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (
          field === StockEntryTable.Warranty &&
          (col.field === StockEntryTable.Warranty_Start_Date ||
            col.field === StockEntryTable.Warranty_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.Insurance &&
          (col.field === StockEntryTable.INC_Start_Date ||
            col.field === StockEntryTable.INC_end_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.AMC &&
          (col.field === StockEntryTable.AMC_Start_Date ||
            col.field === StockEntryTable.AMC_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        }

        return col.field === field ? { ...col, hideable: !col.hideable } : col;
      })
    );
  };
  const visibleColumns = columns.filter((col) => !col.hideable);

  return (
    <>
      {pageType === PageFor.GENERAL &&
        <>
        
          <Navbar NavType={LicenseTypes.SUBSIDIARY} />
          <Title>Stock Balance</Title>
        </>
    }

      <div className={`stock-balance-add${pageType === PageFor.GENERAL ? "":"__modal"}`}>
        <ItemDetails />
        <div className="stock-balance-add__row row g-0">
          {totalData.map((data, index) => (
            <div
              className={`col stock-balance-add__row--${
                data.title === "Sub Store" || data.title === "Stock In Hand"
                  ? "sub"
                  : "main"
              }`}
              key={index}
              onClick={() => {
                if (data.title === "Total Location") {
                  setLocationDetails(!locationDetails);
                }
              }}
            >
              <img src={data.image} alt="" />
              <span>{data.title}</span>
              <b>{data.count}</b>
            </div>
          ))}
          <div className="col-4 flex-end">
            <Button onClick={() => setViewConfig(!viewConfig)}>
              <img src={CheckAll} alt="" />
              Check All configurations
            </Button>
            <label
              className="add-stock-entry__block--filter"
              onClick={() => setFilterColumns(!filterColumns)}
            >
              <img src={Filter} alt="" /> Filter Column
              <img src={DownArrow} alt="" />
            </label>
            {filterColumns && (
              <div className="add-stock-entry__block--filter-checkboxes">
                {columns
                  .filter(
                    (th) =>
                      ![
                        StockEntryTable.Warranty_Start_Date,
                        StockEntryTable.Warranty_End_Date,
                        StockEntryTable.AMC_Start_Date,
                        StockEntryTable.AMC_End_Date,
                        StockEntryTable.INC_Start_Date,
                        StockEntryTable.INC_end_Date
                      ].includes(th.field as StockEntryTable)
                  )
                  .map((col) => (
                    <div key={col.field}>
                      <Checkbox
                        checked={col.hideable ? false : true}
                        onChange={() => {
                          handleColumnToggle(col.field);
                        }}
                      />
                      <Label>{col.headerName}</Label>
                    </div>
                  ))}
                <Button
                  mode="cancel"
                  onClick={() => setFilterColumns(!filterColumns)}
                />
              </div>
            )}
          </div>{" "}
        </div>
        <div className="stock-balance-add__search row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search" />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={options}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Filter Stock Location"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="stock-balance-add__tableblock">
          <TableContainer className="stock-balance-add__table">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {visibleColumns
                    .filter((th) =>
                      [
                        StockEntryTable.SL_No,
                        StockEntryTable.Serial_No,
                        StockEntryTable.Batch,
                        StockEntryTable.Expiry,
                        StockEntryTable.Maintained_By,
                        StockEntryTable.AMC_Enabled,
                        StockEntryTable.Geo_Location,
                        StockEntryTable.Stock_Location,
                        StockEntryTable.Warranty,
                        StockEntryTable.AMC,
                        StockEntryTable.Insurance
                      ].includes(th.field as StockEntryTable)
                    )
                    .map((th: TableHeaderProps, index: React.Key) => {
                      return (
                        <TableCell
                          key={index}
                          rowSpan={
                            [
                              StockEntryTable.SL_No,
                              StockEntryTable.Serial_No,
                              StockEntryTable.Batch,
                              StockEntryTable.Expiry,
                              StockEntryTable.Maintained_By,
                              StockEntryTable.AMC_Enabled,
                              StockEntryTable.Geo_Location,

                              StockEntryTable.Stock_Location
                            ].includes(th.field as StockEntryTable)
                              ? 2
                              : 1
                          }
                          colSpan={
                            [
                              StockEntryTable.Warranty,
                              StockEntryTable.AMC,
                              StockEntryTable.Insurance
                            ].includes(th.field as StockEntryTable)
                              ? 2
                              : 1
                          }
                        >
                          {th.headerName}
                        </TableCell>
                      );
                    })}
                </TableRow>
                <TableRow>
                  {visibleColumns
                    .filter((th) =>
                      [
                        StockEntryTable.Warranty_Start_Date,
                        StockEntryTable.Warranty_End_Date,
                        StockEntryTable.AMC_Start_Date,
                        StockEntryTable.AMC_End_Date,
                        StockEntryTable.INC_Start_Date,
                        StockEntryTable.INC_end_Date
                      ].includes(th.field as StockEntryTable)
                    )
                    .map((th: TableHeaderProps, index: React.Key) => {
                      return (
                        <>
                          <TableCell key={index}>{th.headerName}</TableCell>
                        </>
                      );
                    })}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  {visibleColumns.map((th: TableHeaderProps, index) => {
                    if (th.field === StockEntryTable.SL_No) {
                      return <TableCell id="td-center">{index + 1}</TableCell>;
                    } else if (th.field === StockEntryTable.Serial_No) {
                      return <TableCell>1 </TableCell>;
                    } else if (th.field === StockEntryTable.Batch) {
                      return <TableCell>batch </TableCell>;
                    } else if (th.field === StockEntryTable.Expiry) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />{" "}
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Warranty_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Warranty_End_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Maintained_By) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.AMC_Enabled) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.AMC_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.AMC_End_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Geo_Location) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.INC_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.INC_end_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Stock_Location) {
                      return <TableCell>Hennur</TableCell>;
                    } else return null;
                  })}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {pageType === PageFor.GENERAL &&
          <Button mode="back" onClick={() => navigate(-1)} />
        }
      </div>

      <CustomModal
        isOpen={locationDetails}
        onRequestClose={() => setLocationDetails(!locationDetails)}
        contentComponent={<LocationDetails setModalFlag={setLocationDetails} />}
        style={ViewModalStyles}
      />
      <CustomModal
        isOpen={viewConfig}
        onRequestClose={() => setViewConfig(!viewConfig)}
        contentComponent={<ViewConfiguration setModalFlag={setViewConfig} />}
        style={ViewConfigurationStyles}
      />
    </>
  );
};

export default StockBalanceAdd;
